function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Typography } from '@material-ui/core';
import { InputFormatter, LinkedInputFormatter, TextFormatter } from '../Formatter';
const baseProps = {
  format: '(###) ###-####'
};
const baseInputProps = { ...baseProps,
  type: 'tel',
  inputProps: {
    inputMode: 'tel'
  }
};

const PhoneNumber = props => React.createElement(TextFormatter, _extends({
  renderText: phoneNumber => React.createElement(Typography, null, React.createElement("a", {
    href: `tel:${phoneNumber}`
  }, phoneNumber))
}, baseProps, props));

const PhoneNumberInput = props => React.createElement(InputFormatter, _extends({}, baseInputProps, props));

const LinkedPhoneNumberInput = props => React.createElement(LinkedInputFormatter, _extends({
  getValue: value => value.value
}, baseInputProps, props));

export { PhoneNumber, PhoneNumberInput, LinkedPhoneNumberInput };